import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface TourState {
  dashboardTourCompleted: boolean
  incomeTourCompleted: boolean
  expensesTourCompleted: boolean
  expensesDisclaimerAcknowledged: boolean

  setTourCompleted: (tour: string) => void
  setExpensesDisclaimerAcknowledged: (acknowledged: boolean) => void
}

export const useTourStore = create<TourState>()(
  persist(
    (set) => ({
      dashboardTourCompleted: false,
      incomeTourCompleted: false,
      expensesTourCompleted: false,
      expensesDisclaimerAcknowledged: false,
      setTourCompleted: (tour: string) => set((state) => ({ ...state, [tour]: true })),
      setExpensesDisclaimerAcknowledged: (acknowledged) => set({ expensesDisclaimerAcknowledged: acknowledged })
    }),
    {
      name: 'tour-storage',
      storage: createJSONStorage(() => localStorage)
    }
  )
)
